import { axiosBaseQuery } from '../../../lib/axios'
import { createApi } from '@reduxjs/toolkit/query/react'

export const errorLoggingApi = createApi({
  reducerPath: 'errorLoggingApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    logError: builder.mutation({
      query: (formValues) => ({
        url: 'front/elogger',
        method: 'POST',
        data: { payload: formValues },
        headers: {
          'X-App-Secret':
            'nZsicoqv0p3HjZ8qW5ipTtnhqGgh5FBaBifjcrFrvU3WMsdk9uZYZKffymwY',
        },
      }),
    }),
  }),
})

export const { useLogErrorMutation } = errorLoggingApi
